import type { LatencySurface } from "@/api/observability";

/**
 * 지연 탭의 surface 표시 라벨이다.
 *
 * 요청을 받는 쪽 네 개(`api`·`admin_api`·`internal_api`·`mcp`)는 그 API 의 고유 이름이라 원문을
 * 쓴다. 요청을 보내는 쪽 하나만 방향을 뜻하는 한국어로 표시한다. 어느 상류인지는 surface 가
 * 아니라 operation 앞부분(`training GET /...`)이 표시한다. 그래서 라벨에는 넣지 않는다.
 *
 * Owns: surface 표시 어휘.
 * Does not own: surface 값 자체. 서버 계약이라 `@/api/observability` 가 소유한다.
 */
const SURFACE_LABELS: Record<LatencySurface, string> = {
  api: "API",
  admin_api: "Admin API",
  internal_api: "Internal API",
  mcp: "MCP",
  upstream: "상류",
};

/** 어휘 밖의 값은 원문 그대로 표시한다. 서버가 값을 추가했지만 화면이 아직 모를 때가 그렇다. */
export function describeLatencySurface(surface: LatencySurface): string {
  return SURFACE_LABELS[surface] ?? surface;
}
